import { Content } from "@/services/content/types";
import classNames from "classnames";
import Article from "./linked-content/article";
import Play from "./linked-content/play";
import Podcast from "./linked-content/podcast";

type ArticleFieldsWithType = Content.Entry["fields"] & {
  type?: string;
  hideThumbnailImage?: boolean;
};

type Props = {
  linkedContent?: Content.Entry[];
  showLinkedContent?: boolean;
  compactMode?: boolean;
  darkMode?: boolean;
  bigLargeArticle?: boolean;
  fontWeight?: string;
  highlighted?: string;
  teaserLayoutType?: string;
  interviewMode?: boolean;
};

const TeaserLinkedContent = ({
  linkedContent,
  showLinkedContent = false,
  compactMode = true,
  darkMode = false,
  bigLargeArticle = false,
  fontWeight = "font-semibold",
  highlighted,
  teaserLayoutType,
  interviewMode = false,
}: Props) => {
  return (
    <>
      {showLinkedContent && (
        <div
          className={classNames(
            "[&>*:first-child]:mt-0 mt-4 [&>*]:pb-4 [&>*]:mb-4",
            teaserLayoutType
              ? "[&>*]:border-b [&>*:last-child]:border-0 [&>*:last-child]:mb-0 [&>*:last-child]:pb-0"
              : "[&>*:last-child]:border-0 [&>*:last-child]:mb-0 [&>*:last-child]:mt-0 ",
            darkMode
              ? "text-static-white !border-black-400 p-4"
              : "border-sand-600",
            highlighted === "Nivå 1(röd)"
              ? "!border-red-950 text-static-white"
              : "",
            highlighted === "Nivå 2(beige)" ? "!border-sand-900 " : "",
          )}
        >
          {linkedContent?.map((item) => {
            if (item.sys.contentType.sys.id === "article") {
              return (
                <Article
                  key={item.sys.id}
                  highlighted={highlighted}
                  article={item}
                  compactMode={compactMode}
                  darkMode={darkMode}
                  fontWeight={fontWeight}
                  teaserLayoutType={teaserLayoutType}
                  interviewMode={interviewMode}
                />
              );
            }

            if (
              item.sys.contentType.sys.id === "play" ||
              item.sys.contentType.sys.id === "play-episode"
            ) {
              return (
                <Play
                  key={item.sys.id}
                  play={item}
                  compactMode={compactMode}
                  darkMode={darkMode}
                  fontWeight={fontWeight}
                  hideThumbnailImage={
                    (item.fields as ArticleFieldsWithType)?.hideThumbnailImage
                  }
                />
              );
            }

            if (item.sys.contentType.sys.id === "podcast-episode") {
              return (
                <Podcast
                  key={item.sys.id}
                  podcast={item}
                  compactMode={compactMode}
                  darkMode={darkMode}
                  fontWeight={fontWeight}
                />
              );
            }

            return null;
          })}
        </div>
      )}
    </>
  );
};

export default TeaserLinkedContent;
